import Device from './../../devices/device';
import getAppConfig from "../../config/appConfig";
import * as playerConstants from "../../utils/playerConstants";

import PlayerUtil from './../../devices/all/PlayerUtil';
import RequestManager from '../../requests/RequestManager';
import ManifestTask from '../../utils/webinitiator/requests/ManifestTask';

class SonyPlayerUtil extends PlayerUtil {

  constructor() {
    super();
  }

  resolveStreamType(encodes, provider, isLive) {

    if(isLive) {
      return playerConstants.HLS_KR;
    }

    if(encodes === null || encodes.length < 1) {
      return null;
    }

    // All devices except nagra can play *SS single* and SS_MA so this is the prefered streamType of the app (TODO, is it safe?)
    let preferedStreamType = playerConstants.SS;
    let preferedStreamType_ma = playerConstants.SS_MA;

    let streamType = null;


    let i;
    // First priority: test if we can play prefered streamType with MA
    let ifstreamType_ma = this.ifMultipleAudio(preferedStreamType, false);
    if(ifstreamType_ma) {
      // TODO change to find/filter ES6 syntax
      for(i = 0; i < encodes.length; i++) {
        if(preferedStreamType_ma === encodes[i]) {
          streamType = preferedStreamType_ma; // We found a stream type multipleaudio, we play it
        }
      }
    }
    // Second priority: single, if content dont have multiple audio, search for the prefered single
    if(!streamType) {
      // TODO change to find/filter ES6 syntax
      for(i = 0; i < encodes.length; i++) {
        if(preferedStreamType === encodes[i]) {
          streamType = encodes[i]; // We found a stream type multipleaudio, we play it
        }
      }
    }
    // Third priority: if content dont have the pefered in single, search for another single device supports
    if(!streamType) {
      let device_config = Device.getDevice().getConfig();
      let supported_stream_types_vod = device_config.supported_stream_types.vod;
      let j;
      // TODO change to find/filter ES6 syntax
      for(i = 0; i < device_config.supported_stream_types.vod.length; i++) {
        // skip prefered stream type, we check this one above (single and multiple and wasnt founded)
        if(supported_stream_types_vod[i] === preferedStreamType) {
          continue;
        }
        // TODO change to find/filter ES6 syntax
        for(j = 0; j < encodes.length; j++) {
          if(encodes[j] === supported_stream_types_vod[i]) {
            // First we found
            streamType = encodes[j];
            break;
          }
        }
      }
    }


    return streamType;
  }

  /**
   *
   * @param {*} pgm
   * @param {*} streamType
   * @param {*} provider
   * @param {*} providerCode
   * @param {*} isLive
   */
  replaceSourceMedia(pgm, streamType, provider = null, providerCode = null, isLive = false) {
    console.log(
      '[WI]------------------------------------------------------------------------------------------------------'
    );
    console.log('[WI] 1 replaceSourceMedia ');
    switch (streamType) {
      case playerConstants.SS:
      case playerConstants.SS_MA:
        /**
         * To create webinitiator's url. Both methods below get XML from middleware, the main difference
         * is that one gets/parses manifest from middleware, and the other gets/parses manifest from device
         */
        if (this.parseManifestOnDevice) {
          pgm = this.createWebinitiatorFromDevice(pgm, provider, providerCode, isLive);
        } else {
          pgm = this.createWebinitiatorFromMiddleware(
            pgm,
            provider,
            providerCode,
            isLive
          );
        }
        break;
      default:
        return pgm;
    }

    return pgm;
  }

  async createWebinitiatorFromDevice(pgm, provider, providerCode, isLive) {
    console.log('[WI] 2 createWebinitiatorFromDevice');
    const deviceid = pgm.entry.device_id;

    if (
      providerCode &&
      providerCode === playerConstants.PROVIDER_CODE_FOXV3 &&
      isLive === false
    ) {
      pgm.media = this.transformUrlLicenserFoxV3(pgm.media);
      pgm.media.video_url = pgm.media.video_url.replace('https', 'http');
    }

    // Get manifest, request from device to streaming server
    const mt = new ManifestTask(pgm.media.video_url);
    const manifestXML = await RequestManager.addRequest(mt);
    let customString;

    if (manifestXML) {
      console.log(
        '[WI] 3 createWebinitiatorFromDevice regreso requets de XML y ya hay manifestXML'
      );
      let CUSTOMDATA = '';
      const challenge = pgm.media.challenge ? pgm.media.challenge : null;
      switch (provider) {
        case 'HBO':
          if (isLive == 1) {
            customString = JSON.stringify({
              customdata: challenge ? JSON.parse(challenge) : '',
              device_id: deviceid
            });
            // CUSTOMDATA = Buffer.from(customString).toString('base64');
            CUSTOMDATA = btoa(customString);
          } else {
            CUSTOMDATA = challenge;
          }
          break;
        case 'FOX V3':
          if (isLive == 1) {
            customString = JSON.stringify({
              customdata: challenge ? JSON.parse(challenge) : '',
              device_id: deviceid
            });
            // CUSTOMDATA = Buffer.from(customString).toString('base64');
            CUSTOMDATA = btoa(customString);
          } else {
            CUSTOMDATA = btoa(challenge);
            // CUSTOMDATA = Buffer.from(challenge).toString('base64');
          }
          break;
        default:
          customString = JSON.stringify({
            customdata: challenge ? JSON.parse(challenge) : '',
            device_id: deviceid
          });
          CUSTOMDATA = btoa(customString);
          // CUSTOMDATA = Buffer.from(customString).toString('base64');
          break;
      }

      console.log('[WI] 4 createWebinitiatorFromDevice > getProtectionHeaderFromManifest');
      const protectionObject = this.getProtectionHeaderFromManifest(manifestXML);

      // const LA_URL = pgm.media.server_url || (protectionObject && protectionObject.DATA && protectionObject.DATA.LA_URL);
      let LA_URL = pgm.media && pgm.media.server_url;
      if(!LA_URL) {
        if(protectionObject && protectionObject.DATA && protectionObject.DATA.LA_URL) {
          LA_URL = protectionObject.DATA.LA_URL;
        }
      }
      if(!LA_URL) {
        LA_URL = '';
      }

      const KID = protectionObject.KID;
      const CHECKSUM = protectionObject.CHECKSUM;
      const CONTENT = pgm.media.video_url;

      console.log('[createWebinitiatorFromDevice] LA_URL', LA_URL);
      console.log('[createWebinitiatorFromDevice] KID', KID);
      console.log('[createWebinitiatorFromDevice] CHECKSUM', CHECKSUM);
      console.log('[createWebinitiatorFromDevice] CONTENT', CONTENT);
      console.log('[createWebinitiatorFromDevice] CUSTOMDATA', CUSTOMDATA);

      let urlXmlInitiator = this.getUrlXMLInitiator(
        CONTENT,
        LA_URL,
        LA_URL ? KID : '',
        LA_URL ? CHECKSUM : '',
        LA_URL ? CUSTOMDATA : ''
      );

      console.log('[createWebinitiatorFromDevice] 5 createWebinitiatorFromDevice > hay url WI ', urlXmlInitiator);

      pgm.media.video_url = urlXmlInitiator;
    }

    console.log('[createWebinitiatorFromDevice] return nueva pgm', pgm);
    console.log(
      '[WI]++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++'
    );

    return pgm;
  }

  /**
   * To get webinitiator for Smooth streaming - Playready
   * @param {*} pgm
   * @param {*} streamType
   * @param {*} provider
   * @param {*} providerCode
   * @param {*} isLive
   */
  createWebinitiatorFromMiddleware(pgm, provider, providerCode, isLive) {
    const endpoint = `${getAppConfig().end_point_middleware}web-initiator`;
    if (
      providerCode &&
      providerCode === playerConstants.PROVIDER_CODE_FOXV3 &&
      isLive === false
    ) {
      pgm.media = this.transformUrlLicenserFoxV3(pgm.media);
      pgm.media.video_url = pgm.media.video_url.replace('https', 'http');
    }
    const params = {
      manifest: encodeURIComponent(pgm.media.video_url),
      laurl: pgm.media.server_url ? encodeURIComponent(pgm.media.server_url) : '',
      challenge: pgm.media.challenge ? encodeURIComponent(pgm.media.challenge) : '',
      deviceid: encodeURIComponent(getAppConfig().device_id),
      islive: isLive === true ? 1 : 0
    };
    if (provider) {
      params.provider = provider;
    }
    const query = Object.entries(params)
      .map(param => param.join('='))
      .join('&');
    pgm.media.video_url = `${endpoint}?${query}`;

    return pgm;
  }
}

export default SonyPlayerUtil;



// WEBPACK FOOTER //
// ./src/devices/sony/PlayerUtil.js